import { render, staticRenderFns } from "./GuestChatWidget.vue?vue&type=template&id=495ad8ee&scoped=true"
import script from "./GuestChatWidget.vue?vue&type=script&lang=js"
export * from "./GuestChatWidget.vue?vue&type=script&lang=js"
import style0 from "./GuestChatWidget.vue?vue&type=style&index=0&id=495ad8ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495ad8ee",
  null
  
)

export default component.exports